/* eslint-disable import/no-extraneous-dependencies */
import beautify from 'xml-beautifier';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import XMLViewer from 'react-xml-viewer';

const customThemeXMLViewer = {
	attributeKeyColor: '#0074D9',
	attributeValueColor: '#2ECC40',
};

type TProps = {
	id?: string;
	type: 'Policy';
	XMLParse: string;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ModalPolicyView = (props: TProps) => {
	const [copied, setCopied] = useState(false);

	const result = beautify(props.XMLParse);

	useEffect(() => {
		if (copied) {
			toast.info('XML successfully copied to clipboard');
			setCopied(false);
		}
	}, [copied]);

	return (
		<div
			className="modal fade"
			id={props.id ?? 'modalPolicyView'}
			data-backdrop="static"
			data-keyboard="false"
			tabIndex={-1}
			aria-labelledby="modalPolicyViewLabel"
			aria-hidden="true">
			<div className="modal-dialog modal-xl">
				<div className="modal-content">
					{/* header */}
					<div className="modal-header">
						<h4 className="modal-title" id="modalPolicyViewLabel">
							<i className="bi bi-filetype-xml text-dark mr-2" /> Policy XML
							File Viewer
						</h4>
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close">
							<i
								className="bi bi-x-square-fill bg-light"
								title=""
								data-toggle="tooltip"
								data-original-title="Close"
							/>
						</button>
					</div>

					{/* body */}
					<div
						className="modal-body overflow-scroll"
						style={{maxHeight: '40rem'}}>
						<div className="row">
							<XMLViewer
								indentSize={4}
								collapsible
								xml={result}
								theme={customThemeXMLViewer}
							/>
						</div>
					</div>

					{/* button close */}
					<div className="modal-footer justify-content-between">
						<CopyToClipboard
							text={props.XMLParse}
							onCopy={() => setCopied(true)}>
							<button className="btn btn-link">
								<i className="bi bi-clipboard mr-1" />
								Copy to clipboard
							</button>
						</CopyToClipboard>

						<button
							type="button"
							className="btn btn-secondary"
							data-dismiss="modal">
							<i className="bi bi-x  mr-2" />
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModalPolicyView;
